/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LegalAgreementLanguage } from './';
import {
    LegalAgreementLanguageFromJSON,
    LegalAgreementLanguageFromJSONTyped,
    LegalAgreementLanguageToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalAgreementDraftContentResource
 */
export interface LegalAgreementDraftContentResource {
    /**
     * 
     * @type {LegalAgreementLanguage}
     * @memberof LegalAgreementDraftContentResource
     */
    language: LegalAgreementLanguage;
    /**
     * Draft content for this language.
     * HTML is stored as authored by Malt admins. User-facing rendering must sanitize or isolate this HTML before injecting it into the DOM.
     * 
     * @type {string}
     * @memberof LegalAgreementDraftContentResource
     */
    content: string;
}

/**
 * Check if a given object implements the LegalAgreementDraftContentResource interface.
 */
export function instanceOfLegalAgreementDraftContentResource(value: object): value is LegalAgreementDraftContentResource {
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function LegalAgreementDraftContentResourceFromJSON(json: any): LegalAgreementDraftContentResource {
    return LegalAgreementDraftContentResourceFromJSONTyped(json, false);
}

export function LegalAgreementDraftContentResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalAgreementDraftContentResource {
    if (json == null) {
        return json;
    }
    return {
        
        'language': LegalAgreementLanguageFromJSON(json['language']),
        'content': json['content'],
    };
}

export function LegalAgreementDraftContentResourceToJSON(value?: LegalAgreementDraftContentResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'language': LegalAgreementLanguageToJSON(value['language']),
        'content': value['content'],
    };
}

